import { useEffect, useState } from 'react'
import FenApi from '../api/FenApi'
import { createGlobals } from '../context/createGlobals'
import { useLocalStorage } from './useLocalStorage'

const LOCAL_STOREAGE_EXTERAN_SYSTEM = 'podo_external_systems'

const initState = {
  systemsWithEkom: []
}
const { useGlobalState } = createGlobals(initState)
let isFetch = false

export const useExternalSystems = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [init, setInit] = useState(false)

  const [data, setData] = useGlobalState('systemsWithEkom')
  const [storedData, setStoredData] = useLocalStorage<string[]>(LOCAL_STOREAGE_EXTERAN_SYSTEM, 60)

  const fetchData = async (force?: boolean) => {
    if (isFetch && !force) {
      setInit(true)
      return
    }
    isFetch = true

    setError('')
    setLoading(true)
    try {
      if (storedData === undefined || force) {
        const result = await FenApi.getExternalSystemWithEkom()
        const systemWithEkom = result.map(s => s.url)
        setStoredData(systemWithEkom)
        setData(systemWithEkom)
        return systemWithEkom
      } else {
        setData(storedData)
        return storedData
      }
    } catch (error: any) {
      setError(error.toString())
    } finally {
      setInit(true)
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { loading, error, data, init, fetchData }
}
